import { makeHttpRequest } from "@/shared";

import { mapPointsFromServer } from "./mappers/mapPointsFromServer";

export const getEmployeePoints = async (id) => {
    const response = (
        await makeHttpRequest({
            url: `/human/employee/accessible-points/${id}`,
            method: "GET",
        })
    ).data;

    return { data: mapPointsFromServer(response.data) };
};
